/**
 * Constants for dashboard configuration
 * Centralizes magic numbers and configuration values
 */

// Pagination settings
export const PAGINATION = {
  MOBILE_TIMELINE_PAGE_SIZE: 3,
  FOLLOW_ON_PAGE_SIZE: 3,
  DATA_TABLE_PAGE_SIZE: 10
}

// Error handling
export const ERROR_MESSAGES = {
  USER_FRIENDLY: 'Please refresh your browser or try again later.',
  SERVER_ERROR_TITLE: 'Server Error'
}

// Notification delays
export const NOTIFICATION_DELAYS = {
  ERROR_DISPLAY: 5000
}

// Dashboard icons
export const DASHBOARD_ICONS = {
  DASHBOARD: 'BarChart3',
  CALENDAR: 'Calendar'
}

// Status mappings
export const STATUS_COLORS = {
  ACTIVE: 'bg-green-100 text-green-800',
  CLOSED: 'bg-gray-100 text-gray-800',
  DEFAULT: 'bg-blue-100 text-blue-800'
}
